import type { TIntention } from '../models/Intention.types'

export const getRemainingIntentionTime = (intention: TIntention, referenceTimeMs: number): number =>
  Math.min(Math.ceil(Math.abs(new Date(intention.publishedUntil).getTime() - referenceTimeMs) / (60 * 60 * 1000)), 48)
